/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import {
  AnalyzerDish,
  Switch,
  TimeWarning,
  Snapshot,
  AnalyzerDataSetting,
} from '../';

export type Analyzer = {
  id: number;
  active_snapshot: number;
  analyzer_switch: AnalyzerSwitch[];
  analyzer_dish: AnalyzerDish[];
  name: string;
  ip: string;
  port: number;
  type: 0 | 1 | 3 | 4;
  number_of_ports: number;
  serial: string;
  firmware: string;
  memo: string;
  demo_start_date: string;
  mode: 0 | 1;
  enabled: boolean | number;
  status: boolean;
  snapshots: Snapshot[];
  modules: number[];
  time_warning: TimeWarning | null;
  data_settings: AnalyzerDataSetting;
  mode_before_crosspol: 0 | 1 | null;
  in_time_share: boolean;
};

export type AnalyzerSwitch = {
  id: number;
  switch_channel: number;
  analyzer_id: number;
  switch_id: number;
  switch_output?: number;
  switch?: Switch;
};

export enum AnalyzerType {
  LPT3000RX4,
  LPT3000R,
  AVCOMSBS22150E,
  ANRITSUMS27103A,
}
